var React   = require("react");

var Ellipsis = React.createClass({
  PropTypes: {
    text: React.PropTypes.string.isRequired,
    maxLines: React.PropTypes.number.isRequired,
  },

  render : function(){
    const { text, maxLines } = this.props;

    return (
      <div className="ellipsis-ie11" style={{ maxHeight: `${maxLines*23}px`, wordWrap: 'break-word' }}>
        {text}
      </div>
    );
  }
});

module.exports = Ellipsis;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/ellipsis_polyfill.jsx